import React from "react";
import { cn } from "@utils";

export const LedgerItemTemplate = ({
  left,
  title,
  amount,
  amountClassName,
  dateText,
  dateClassName,
  onClick,
  containerClassName,
  children,
  onClickActionLabel,
  trailing,
}) => {
  return (
    <div
      className={cn("pb-4 flex flex-col gap-3 first:pt-4", containerClassName)}
    >
      <div className="flex items-start">
        {left}
        <div
          className={cn(
            "flex flex-col gap-2 justify-start grow items-stretch",
            onClick && "cursor-pointer"
          )}
          onClick={onClick}
        >
          <div className="flex justify-between grow font-normal gap-2 text-sm">
            <span>{title}</span>
            <span className={cn("whitespace-nowrap", amountClassName)}>
              {amount}
            </span>
          </div>
          <div className="flex items-center justify-between grow font-normal gap-2">
            <span
              className={cn(
                "text-xs/6 text-zinc-500 font-light",
                dateClassName
              )}
            >
              {dateText}
            </span>
            <div className="flex items-center gap-1">
              {onClickActionLabel}
              {trailing}
            </div>
          </div>
        </div>
      </div>
      {children}
    </div>
  );
};

export const LedgerCheckboxLabel = ({ children }) => (
  <label className="w-12 shrink-0 p-4 -mt-3 -ml-4 -mr-1 cursor-pointer flex items-center justify-center">
    {children}
  </label>
);

export const LedgerConnector = ({ isFirst }) => (
  <div className="w-3 h-4 mx-2 mt-1 shrink-0 relative">
    <div
      className={cn(
        "w-full absolute bottom-1/2 -left-0.5 border-b border-l border-zinc-400 ml-[1px]",
        isFirst ? "h-12" : "h-7"
      )}
    />
  </div>
);
